module.exports = __webpack_public_path__ + "img/step2-7.7c9cc742.png";